import React, { useState } from "react";
import SearchBar from "../../reusebale/searchBar";
import db from "../../../db/index.json";
import TenantsTable from "../tenants/tenantsTable";
import MainTenantSection from "../tenants/tenantsDetail/main";
import FilterPopup from "../../popup/filterPopup";
import DetailMain from "../maintenance/maintanance-detail/detailMain";
// import PersonalInfo from "../profile-complete/personal-information/personal-info";
import DetailLeaseMain from "../leases/leaseDetail/main";
import { useDispatch } from "react-redux";
// import * as LeaseDataAction from "../../../store/actions/lease/LeaseAction"
import * as LeaseDataAction from "../../../store/actions/lease/LeaseAction";

const TenantsSection = ({ toggleMaintainanceTable, onTriggerCard, onBack }) => {
  const { tenants } = db;

  const [showTable, setShowTable] = useState("table"); // Default: Table show ho raha hai
  const [showFilter, setShowFilter] = useState(false);
  const [recordId, setRecordId] = useState();
  const [showDetail, setShowDetail] = useState("");
  const [recordLeaseId, setLeaseRecordId] = useState();
  const [search, setSearch] = useState("");
  const [seletedTenant, setSelectedTenant] = useState();
  const dispatch = useDispatch();

  const openPopup = () => {
    setShowFilter(true);
  };

  const closePopup = () => {
    setShowFilter(false);
  };

  const toggleDetail = (tenant) => {
    setSelectedTenant(tenant);
    setShowTable("detail");
  };

  const toggleDetailMaintain = () => {
    setShowTable("MaintainanceDetails");
  };

  const handleCreateMaintain = () => {
    setShowTable("createMaintainance"); // State toggle karein
  };

  const toggleDetailProperty = () => {
    setShowTable("detail");
  };

  const handleShowProfile = (item) => {
    setShowTable(item);
  };

  const toggleTable = () => {
    setShowTable("table"); // State toggle karein
  };

  const handleCreateLease = () => {
    setShowTable("createLease"); // State toggle karein
  };

  const leaseDetail = (status, id) => {
    setShowDetail(status);
    setLeaseRecordId(id);
    setShowTable("leasedetail"); // State toggle karein
  };

  return (
    <div>
      {(() => {
        switch (showTable) {
          case "table":
            return (
              <div className="h-screen w-full">
                <div className="h-[10vh]">
                  <SearchBar
                    title={tenants.title}
                    desc={tenants.desc}
                    onSubmit={openPopup}
                    value={search}
                    onSearchChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    isFilter={true}
                  />
                </div>
                <div className="h-[90vh]">
                  <TenantsTable
                    onViewDetails={toggleDetail}
                    searchTerm={search}
                  />
                </div>
              </div>
            );
          case "detail":
            return (
              <MainTenantSection
                seletedTenant={seletedTenant}
                onBack={toggleTable}
                onViewMaintainDetails={(item) => {
                  setRecordId(item);
                  toggleDetailMaintain(item);
                }}
                onViewMaintainCreate={handleCreateMaintain}
                onAction={(item) => {
                  handleShowProfile(item);
                }}
                toggleLeaseDetail={leaseDetail}
                onTriggerCard={onTriggerCard}
                toggleCreateLease={handleCreateLease}
              />
            );
          case "MaintainanceDetails":
            return (
              <DetailMain
                recordId={recordId._id}
                onBack={toggleDetailProperty}
              />
            );
          // case "General Info":
          //   return <PersonalInfo clases="mt-5" onBack={toggleDetailProperty} />;
          case "leasedetail":
            return (
              <DetailLeaseMain
                onBack={toggleTable}
                showDetailStatus={showDetail}
                recordId={recordLeaseId}
                onViewDetailsMaintain={(item) => {
                  setRecordId(item);
                  toggleDetailMaintain(item);
                }}
                onEditLease={(leaseDetails) => {
                  handleCreateLease();
                  dispatch(LeaseDataAction.LeaseDetailAction(leaseDetails));
                }}
                onMaintainancePage={toggleMaintainanceTable}
                onTriggerCard={onTriggerCard}
              />
            );
          default:
            break;
        }
      })()}

      {showFilter && <FilterPopup onBack={closePopup} onFilter={closePopup} />}
    </div>
  );
};

export default TenantsSection;
